import { render } from "./TimeInput.vue?vue&type=template&id=11637c66&scoped=true&ts=true"
import script from "./TimeInput.vue?vue&type=script&lang=ts"
export * from "./TimeInput.vue?vue&type=script&lang=ts"

import "./time-input.scss?vue&type=style&index=0&id=11637c66&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11637c66"]])

export default __exports__